import { RadioGroupProps } from "@mui/material/RadioGroup/RadioGroup"
import React from "react"
import { StyledRadioGroup, StyledRadioGroupLabel } from "./styles"

interface IProps extends RadioGroupProps {
  label?: string
}

export const RadioGroup = ({ label, ...props }: IProps) =>
  <div>
    {label && <StyledRadioGroupLabel>{label}</StyledRadioGroupLabel>}
    <StyledRadioGroup {...props} />
  </div>

